<template>
    <div class="fixed md:top-8 md:left-8 h-96 w-96 z-40 md:inset-0 md:p-4 overflow-y-hidden">
        <div class="absolute bg-white border w-60 md:w-80 h-fit md:h-80 top-4 left-4 md:top-10 md:left-10 rounded shadow">
            <div class="p-2">
                <div class="flex flex-col px-2 pb-4">
                    <button type="button" @click="closeModal"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                    <div class="px-4 mb-4">
                        <h2 class="text-gray-700 font-bold text-base md:text-lg mb-4 keepall text-center">서비스 이용 안내</h2>
                        <p class="mb-2 text-gray-700 text-sm md:text-base text-center keepall">본 서비스는 베타 버전으로 운영되고 있습니다. 관련 개선사항이나 문의사항은 아래 링크로 의견을 주시면 감사하겠습니다.</p>
                    </div>
                    <div class="bg-gray-100 w-full h-12 text-center flex flex-row justify-center items-center mb-5">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-blue-600 w-3 h-3 md:w-4 md:h-4 mr-1.5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                        </svg>
                        <span class="text-blue-600 text-sm md:text-base font-medium hover:underline">
                            <a href="https://forms.gle/gLDVysGBUAzNSmT56" target="blank">
                            링크 바로가기
                            </a>
                        </span>
                    </div>
                    <div class="text-center text-gray-700 font-medium text-xs md:text-sm">(주)스텔스랩</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default ({
    name: "PopUpView",
    methods: {
        closeModal() {
            this.$emit("sendClose", false)
            // console.log("모달창꺼짐")
        },
    }
})
</script>

<style scoped>
.keepall{
    word-break: keep-all;
}
</style>